import { api } from '../../api/client';
import type { ComponentBrief } from '../components/api';

export type SerialStatus = 'in_stock' | 'reserved' | 'issued' | 'scrapped' | 'missing';

export interface SerialUnit {
  id: string;
  code: string;
  component_id: string;
  serial: string | null;
  source: 'manufacturer' | 'internal';
  status: SerialStatus;
  current_location_id: string | null;
  location_name: string | null;
  purchase_line_id: string | null;
  project_id: string | null;
  note: string | null;
  created_at: string;
}

export interface SerialHistoryRow {
  movement_id: string;
  occurred_at: string;
  movement_type: string;
  quantity: string;
  location_id: string | null;
  location_name: string | null;
  note: string | null;
}

export interface SerialSummary {
  total: number;
  by_status: Record<string, number>;
}

export const listSerials = (componentId: string, status?: SerialStatus, query?: string) => {
  const params = new URLSearchParams({ component_id: componentId });
  if (status) params.set('status', status);
  if (query) params.set('query', query);
  return api.get<SerialUnit[]>(`/serials?${params.toString()}`);
};

/** A unit found by its number, with the part it belongs to.
 *
 *  The component travels with it because the search started from a number read
 *  off a device — "which part is this" is the whole question. */
export interface SerialHit {
  unit: SerialUnit;
  component: ComponentBrief;
}

export const searchSerials = (q: string) =>
  api.get<SerialHit[]>(`/serials/search?q=${encodeURIComponent(q)}`);

export const serialSummary = (componentId: string) =>
  api.get<SerialSummary>(`/serials/summary?component_id=${componentId}`);

export const registerSerials = (body: {
  component_id: string;
  serials?: string[];
  count?: number;
  location_id?: string | null;
  note?: string | null;
}) => api.post<SerialUnit[]>('/serials', body);

export const updateSerial = (
  id: string,
  body: { serial?: string | null; note?: string | null },
) => api.patch<SerialUnit>(`/serials/${id}`, body);

export const serialHistory = (id: string) =>
  api.get<SerialHistoryRow[]>(`/serials/${id}/history`);
